import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterEvent, NavigationEnd } from '@angular/router';
import { OverlayService, ModalDefinition } from 'app/services/overlay.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
	public currentPage: string;
	public tagLine = '';

	private subscriptions = new Subscription();

	constructor(
		private overlayService: OverlayService,
		private router: Router,
	) {
		this.router.events.subscribe((routerEvent: RouterEvent) => {
			if (routerEvent instanceof NavigationEnd) {
				this.currentPage = this.stripLocationParameters(routerEvent.url);
			}
		});

		// default to login page
		if (!this.currentPage) {
			this.currentPage = this.stripLocationParameters(this.router.url);
			if (!this.currentPage.startsWith('login')) {
				this.currentPage = 'login';
			}
		}

		this.setRandomTagLine();
	}

	ngOnInit() { }

	ngOnDestroy() {
		if (this.subscriptions) {
			this.subscriptions.unsubscribe();
		}
	}

	public showAbout() {
		const modal: ModalDefinition = { icon: '', title: '', component: { name: 'bb-about-rb' } };
		this.overlayService.createModal(modal);
	}

	public contactUs() {
		window.open('https://www.bluebillywig.com/contact/');
	}

	private stripLocationParameters(url: string) {
		const strippedUrl = url.replace(/\?.*$/, '');
		return strippedUrl.replace(/^\//, '');
	}

	private setRandomTagLine(): void {
		const randomNr = Math.ceil(Math.random() * 8); // 8 options in en_US.json
		// fixed tagline for Percy
		this.tagLine = 'LOGIN_TAGLINE_' + ((window as any)?.Cypress ? 1 : randomNr);
	}
}
